import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import 'remixicon/fonts/remixicon.css';

import '@assets/fa-all.min.js';
import AppCore from '@core/app/AppCore';
import { store } from '@core/store/store';
import { ThemeModeConstants } from '@helpers/theme.helper';
import { ThemeProvider } from '@providers/themeProvider';
import '@styles/globals.css';
import '@styles/index.scss';

const root = createRoot(document.getElementById('nsc-dash')!);
root.render(
  <Provider store={store}>
    <ThemeProvider
      defaultTheme={ThemeModeConstants.DARK}
      storageKey="vite-ui-theme">
      <AppCore />
    </ThemeProvider>
  </Provider>
);
